import * as React from 'react';
import { useSelector } from 'react-redux';

import { useRecommendationsEventsSubscribe } from './hooks/useRecommendationsEventsSubscribe';
import { Recommendations } from '../../components/Recommendations';
import { mapSectionToLandingType } from '../../types/landingType';
import { selectRegionsData } from '../../selectors/mainpage/selectRegionsData';
import { selectPageSection } from '../../selectors/pageSection';
import { useExperimentGroup, useRemovePopularEnabled } from '../../hooks';
import { useApplicationContext } from '../../utils/applicationContext';
import { RECOMMENDATIONS_MANIFEST_INFO_SETTING_KEY } from '../../constants/microfrontend';
import { IManifestInfo } from '../../types/manifestInfo';
import { BX_DESKTOP_BX1106_REDESIGN_RECS_MAINPAGE } from '../../constants/experiments';

const REDESIGN_EXPERIMENT_GROUP = 'B';

export const RecommendationsContainer = () => {
  const { config } = useApplicationContext();

  const section = useSelector(selectPageSection);
  const manifestInfo = config.get<IManifestInfo | null>(RECOMMENDATIONS_MANIFEST_INFO_SETTING_KEY);

  const landingType = React.useMemo(() => mapSectionToLandingType(section), [section]);
  const isEnabled = useRemovePopularEnabled();
  const recommendationsRedesignGroup = useExperimentGroup(BX_DESKTOP_BX1106_REDESIGN_RECS_MAINPAGE);
  const isRedesigned = recommendationsRedesignGroup === REDESIGN_EXPERIMENT_GROUP;

  const { subdomainCityId, subdomainRegionId } = useSelector(selectRegionsData);
  const recommendationsRegionId = subdomainRegionId || subdomainCityId;

  useRecommendationsEventsSubscribe(section);

  if (!manifestInfo) {
    return null;
  }

  if (section === 'new-buildings' || section === 'commercial') {
    return null;
  }

  return (
    <Recommendations
      manifestInfo={manifestInfo}
      regionId={recommendationsRegionId}
      landingType={landingType}
      showFullList={Number(isEnabled)}
      isRedesigned={isRedesigned}
    />
  );
};
